<template>
  <el-row :gutter="20">
    <el-col :span="8"><div class="grid-content ep-bg-purple" />
      <el-card style="">
        <div style="margin-bottom:20px;font-size: 18px;border-bottom: 1px solid var(--el-border-color)">物件工序设置</div>
        <el-table  border="true" stripe :data="wuJianData"  style="width: 100%" max-height="550px"
                   class="line-table success-row" highlight-current-row="true" scrollbar-always-on="true"
                   :cell-style="{ textAlign: 'center'}" :header-cell-style="{textAlign: 'center'}">
          <el-table-column type="index" label="序号" highlight width="60" />
          <el-table-column property="wujian_id" label="物件番号" width="120" />
          <el-table-column property="wujian_short_name" label="物件略称" width="180" >
          <template v-slot="scope">
            <div @click="lineCurrentChange(scope.row)" :class="setClassName(scope.row.id)">{{scope.row.wujian_short_name}}</div>
          </template>
          </el-table-column>
        </el-table>

      </el-card>
    </el-col>
    <el-col v-if="boolStation" :span="7"><div class="grid-content ep-bg-purple" />
      <el-card class="box-card">
        <div style="margin-bottom:10px;font-size: 18px;border-bottom: 1px solid var(--el-border-color)">物件工站设置</div>
        <el-button type="success" @click="dialogAddStation=true">添加物件工站信息</el-button>
        <el-table border="true" stripe :data="stationData"  style="width: 100%;margin-top:10px" highlight-current-row="true"
                  class="success-row" scrollbar-always-on="true" :cell-style="{ textAlign: 'center'}"
                  :header-cell-style="{textAlign: 'center'}">
          <el-table-column type="index" label="序号" width="60" />
          <el-table-column property="stage_name" label="工站名称" width="120" >
            <template v-slot="scope">
              <div @click="stationCurrentChange(scope.row)" :class="setClassName(scope.row.id)">{{scope.row.stage_name}}</div>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="100" align="center">
            <template #default="scope">
              <el-button @click="deleteStation(scope.row.id)" type="danger" link>删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-card>
    </el-col>
    <el-col :span="9" v-if="boolProcesses"><div class="grid-content ep-bg-purple" />
      <el-card class="box-card">
        <div style="margin-bottom:10px;font-size: 18px;border-bottom: 1px solid var(--el-border-color)">物件工序设置-列表</div>
        <el-button type="success" @click="dialogAddProcesses=true">添加工序</el-button>
        <el-table border="true" stripe :data="processesData"  style="width: 100%;margin-top:10px" highlight-current-row="true"
                  class="success-row" scrollbar-always-on="true" :cell-style="{ textAlign: 'center'}"
                  :header-cell-style="{textAlign: 'center'}">
          <el-table-column type="index" label="序号" width="60" />
          <el-table-column property="step_name" label="工序名称" width="120" />
          <el-table-column property="worker_num" label="计划人数" width="100px" >
          <template v-slot="scope">
            <div @click="processesCurrentChange(scope.row)" :class="setClassName(scope.row.id)">{{scope.row.worker_num}}</div>
          </template>
          </el-table-column>
          <el-table-column label="操作" width="100" align="center">
            <template #default="scope">
              <el-button @click="deleteProcesses(scope.row.id)" type="danger" link >删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-card>
    </el-col>
  </el-row>

  <el-dialog title="添加工站信息设置" v-model="dialogAddStation" width="30%">
    <el-form :model="formData" label-width="100px" :rules="rules">
      <el-form-item label="工站：" prop="star">
        <el-select v-model="formData.stage_id" placeholder="工站选择" class="toolbar_item" style="width: 250px">
          <el-option v-for="item in stageData" :key="item.id" :label="item.stage_name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button @click="stageAdd" type="success">添加</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>

  <el-dialog title="添加工序" v-model="dialogAddProcesses" width="30%">
    <el-form :model="formData" label-width="100px" :rules="rules">
      <el-form-item label="工序：" prop="star">
        <el-select v-model="formData.step_id" multiple clearable placeholder="工序选择" class="toolbar_item" style="width: 250px">
          <el-option v-for="item in stepData" :key="item.id" :label="item.step_name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button @click="stepAdd"  type="success">添加</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>

  <el-dialog title="设置" v-model="dialogUpdateProcesses" width="50%">
    <el-form :model="formData" label-width="100px" :rules="rules">
      <el-form-item label="物件名称：" prop="star">
        {{ formData.wujian_name }}
      </el-form-item>
      <el-form-item label="工站名称：" prop="star">
        {{ formData.stage_name }}
      </el-form-item>
      <el-form-item label="工序名称：" prop="star">
        {{ formData.step_name }}
      </el-form-item>
      <el-form-item label="人数设定：" prop="star">
        <el-input-number v-model="formData.worker_num" :min="0"/>
      </el-form-item>
      <el-form-item label="工序顺序：" prop="star">
        <el-input-number v-model="formData.step_num" :min="0" />
      </el-form-item>
      <el-form-item>
        <el-button @click="updateProcesses"  type="success">保存</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
export default {
  name: "ThingProcess",
  props: {
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return {
      //产线table
      wuJianData: [],
      stageData: [],
      stepData:[],
      stationData: [],
      processesData: [],
      formData:{
        stage_id:'',
        step_id:[],
        step_num:'',
        worker_num:''
      },
      boolStation: false,
      boolProcesses: false,
      boolWorker: false,
      dialogAddStation: false,
      dialogAddProcesses: false,
      dialogUpdateProcesses: false,
      wuJianId:'',
      stageId:'',
      currentLineId:'',
      stationLineId:'',
      processesLineId:'',
      rules: {
        star: [{required: true, message: '', trigger: 'blur'}],
      },
    }
  },
  methods:{
    setClassName(id){
      if (id === this.currentLineId  || id === this.stationLineId || id === this.processesLineId){
        return 'line-name';
      }else {
        return 'line-name2';
      }

    },

    getOrderStageByWuJianId(){
      this.$axios.post('am/thingProcess/getStation', this.wuJianId).then(response => {
        let res = response.data
        this.stationData = res.data;

      })
    },
    getStageStepByWuJianId(){
      this.$axios.post('am/thingProcess/getProcesses',this.formData).then(response => {
        let res = response.data
        this.processesData = res.data;
      })
    },
    lineCurrentChange(currentRow){
      this.boolStation = true;
      this.boolProcesses = false;
      this.boolWorker = false;
      this.currentLineId = currentRow.id
      this.wuJianId = currentRow.wujian_id
      this.getOrderStageByWuJianId()
    },
    stationCurrentChange(currentRow){
      this.boolProcesses = true;
      this.stationLineId = currentRow.id
      this.stageId = currentRow.stage_id
      this.formData.stage_id = currentRow.stage_id
      this.formData.wujian_id = this.wuJianId
      this.getStageStepByWuJianId()
    },
    processesCurrentChange(currentRow) {
      this.dialogUpdateProcesses = true;
      this.processesLineId = currentRow.id
      this.$axios.post('am/thingProcess/getStageStep',currentRow.id).then(response => {
        let res = response.data
        this.formData = res.data;
      })

    },
    stageAdd(){
      if (!this.formData.stage_id) {
        return this.$message.error('工站不能为空!')
      }
      this.formData.wujian_id = this.wuJianId
      this.$axios.post('am/thingProcess/addOrderStage',this.formData).then(response => {

      let res = response.data
      if (res.code !== 0) {
        return this.$message.error(res.message);
      }
      this.dialogAddStation = false
        this.getOrderStageByWuJianId()
        this.formData.wujian_id = ''
        this.formData.stage_id =''
        this.formData.step_id = []
        this.formData.step_num =''
        this.formData.worker_num =''
        return this.$message.success('添加成功!')
    })
    },
    stepAdd(){
      if (this.formData.step_id.length === 0) {
        return this.$message.error('工序不能为空!')
      }
      this.formData.wujian_id = this.wuJianId
      this.formData.stage_id = this.stageId
      this.$axios.post('am/thingProcess/addStageStep',this.formData).then(response => {
      let res = response.data
      if (res.code !== 0) {
        return this.$message.error(res.message);
      }

        this.getStageStepByWuJianId()
        this.dialogAddProcesses = false
        this.formData.wujian_id = ''
        this.formData.stage_id =''
        this.formData.stage_num = 0
        this.formData.step_id = []
        this.formData.step_num =''
        this.formData.worker_num =''
        return this.$message.success('添加成功!');
      })
    },
    updateProcesses(){
      this.formData.id = this.processesLineId
      this.$axios.post('am/thingProcess/updateProcesses', this.formData).then(response => {
        let res = response.data
        if (res.code !== 0) {
          return this.$message.error("保存失败！");
        }
        this.getStageStepByWuJianId()
        this.dialogUpdateProcesses = false
        this.formData.wujian_id = ''
        this.formData.stage_id =''
        this.formData.step_id = []
        this.formData.step_num =''
        this.formData.worker_num =''
        return this.$message.success('保存成功!');
      })
    },
    async getWujianList() {
      let {data: res} = await this.$axios.get('/am/thingProcess/getWuJianAll');
      this.wuJianData = res.data;
    },
    async getStageList() {
      let {data: res} = await this.$axios.get('/am/thingProcess/getStageAll');
      this.stageData = res.data;
    },
    async getStepList() {
      let {data: res} = await this.$axios.get('/am/thingProcess/getStepAll');
      this.stepData = res.data;
    },
    deleteStation(id) {
      this.$confirm('你确定要删除吗!', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post('/am/thingProcess/deleteStation', id).then(response => {
          let res = response.data
          if (res.code != 0) {
            return this.$message.error('删除失败!');
          }
          this.getOrderStageByWuJianId()
          return this.$message.success('删除成功!');
        })

      }).catch(() => {
        this.$message.info('已取消删除');
      });
    },
    deleteProcesses(id) {
      this.$confirm('你确定要删除吗!', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post('/am/thingProcess/deleteProcesses', id).then(response => {
          let res = response.data
          if (res.code != 0) {
            return this.$message.error('删除失败!');
          }
          this.getStageStepByWuJianId()
          return this.$message.success('删除成功!');
        })

      }).catch(() => {
        this.$message.info('已取消删除');
      });
    },
  },created() {
    this.getWujianList()
    this.getStageList()
    this.getStepList()
  }
}
</script>

<style scoped>
.el-row {
  margin-bottom: 20px;
}
.el-row:last-child {
  margin-bottom: 0;
}
.el-col {
  border-radius: 4px;
}

.grid-content {
  border-radius: 4px;
  min-height: 36px;
}

.success-row {
  /*--el-table-tr-bg-color: var(--el-color-success-light-9);*/
  /*--el-table-tr-bg-color: var(--el-color-warning-light-9);*/
}
.line-name {
  color:rgb(93, 201, 131);
}

.line-name2 {
  color:rgb(75, 143, 240);
  cursor:pointer;
}
</style>